import React from "react";

function SelectEvents({
  selectedValue,
  setSelectedValue,
  treatments,
  propswidth,
  formFieldColor,
  placeholderText,
  propsStyle,
}) {
  const handleChange = (event) => {
    // events_option_uuid 전환: uuid 문자열이므로 숫자 변환 금지
    setSelectedValue(event.target.value); // 상태 업데이트
    console.log(selectedValue);
  };

  return (
    <div
      className={`formField customSelectWrapper ${
        formFieldColor ? formFieldColor : "white"
      }`}
      style={{ width: `${propswidth}`, ...propsStyle }}
    >
      <select
        id="select-events"
        value={selectedValue || ""}
        onChange={handleChange}
      >
        <option value="">
          {placeholderText ? placeholderText : "진료항목"}
        </option>
        {/* treatments 배열을 사용하여 옵션을 동적으로 생성 */}
        {treatments &&
          treatments.map((item) => (
            <option key={item.value} value={item.value}>
              {item.label}
            </option>
          ))}
      </select>
    </div>
  );
}

export default SelectEvents;
